// extracted by mini-css-extract-plugin
export default {"circle":"NewInfoButton_circle__IgFAS","mymove":"NewInfoButton_mymove__nWWmq","ghghgh":"NewInfoButton_ghghgh__YejyT"};